import css from "./style.scss";
import cx from "classnames";
import { Text } from "preact-i18n";
import QRCode from "react-qr-code";
import Tooltip from "../tooltip";
import { svgIcons } from "../../helpers/svg-helpers";
import { withText } from "preact-i18n";
import {formatNumber} from "../../helpers/formatters-helpers";
import useInvoice from "../../hooks/useInvoice";
import ConnectWallet from "../connect-wallet";

const QrForm = withText(["pay.netamount", "pay.tooltip"])(
  ({ netamount, tooltip, address }) => {
    const { invoice } = useInvoice();
    const { currency, network } = invoice;

    return (
      <div class={cx(css.wrapper)}>
        <div class={cx(css.header, "text-center")}>
          <div class={cx(css.title)}>
            <Text id="payment.amount-to-pay">Amount to pay</Text>
            <Tooltip header={netamount} text={tooltip}>
              {svgIcons.help()}
            </Tooltip>
          </div>
          <div class={cx(css.amount)}>
            {formatNumber(currency?.value)} {currency?.currency}
          </div>
          <div class={cx(css.usd)}>
            ≈ ${Number.parseFloat(currency?.usdAmount).toFixed(2)}
          </div>
          <div class={cx(css.qr)}>
            <QRCode value={address} size={200} />
          </div>
          <div className={cx(css.wallet)}>
            <ConnectWallet amount={currency?.value} to={address} currency={currency?.currency} network={network?.network} />
          </div>
        </div>
      </div>
    );
  }
);
export default QrForm;
